document.addEventListener('DOMContentLoaded', function() {
  const filterForms = document.querySelectorAll('[data-collection-filters-form]');
  
  filterForms.forEach(form => {
    // Aggiungi il filtro al caricamento
    addInStockFilter(form);
    
    // Intercetta l'invio del form e aggiungi il filtro
    form.addEventListener('submit', function(event) {
      addInStockFilter(form);
    });
  });
  
  function addInStockFilter(form) {
    // Rimuovi eventuali campi esistenti per evitare duplicati
    const existingFields = form.querySelectorAll('input[name="filter.v.availability"]');
    existingFields.forEach(field => {
      if (field.type === 'hidden') {
        field.remove();
      }
    });
    
    // Aggiungi sempre il filtro "in stock"
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'filter.v.availability';
    hiddenInput.value = '1';
    form.appendChild(hiddenInput);
  }
});